export default __webpack_public_path__ + "static/media/icon1024.c425713f.png";